module.exports = __webpack_public_path__ + "img/bitkub-logo.svg";